import adminRequest from '@/utils/h5-admin-request'

/**
 * 获取所有印章规则（公开可读，返回去重 ruleCode + remark）
 */
export function getSealRules() {
  return adminRequest({
    url: '/signstore/sealrule/list',
    method: 'get'
  })
}

/**
 * 对比印章点位相似度（ACT004，内部测试页；活动打卡走 signstore.js）
 */
export function compareSealPointsAct004(data) {
  return adminRequest({
    url: '/signstore/sealrule/compareSimilarity/act004',
    method: 'post',
    data: {
      ruleCode: data.ruleCode,
      touchPoints: data.touchPoints,
      activityUserId: data.activityUserId || null,
      authStoreCode: data.authStoreCode,
      coordinateSystem: data.coordinateSystem != null ? data.coordinateSystem : 1
    }
  })
}

/**
 * 追加印章点位到规则（内部录入）
 */
export function addSealPoints(data) {
  return adminRequest({
    url: '/signstore/sealrule/addSealPoints',
    method: 'post',
    data: {
      ruleCode: data.ruleCode,
      sealPoints: data.sealPoints,
      coordinateSystem: data.coordinateSystem,
      remark: data.remark
    }
  })
}
